// extracted by mini-css-extract-plugin
export var bodySections = "_9d-8";
export var gray = "_9d-7";
export var green = "_9d-4";
export var iconContainer = "_9d-9";
export var iconWidgetContainer = "_9d-1";
export var phoneIcon = "_9d-2";
export var red = "_9d-5";
export var statusDot = "_9d-3";
export var widgetContainer = "_9d-0";
export var yellow = "_9d-6";